import showToaster from '../../../../helpers/showToaster';
import uploadDocument from '../../../../actions/siteadmin/ManageShop/uploadDocument';

async function submit(values, dispatch) {
    let documentError = false;

    values.documentList && values.documentList.map((item) => {
        item.fileName ? documentError = false : documentError = true
    })

    let documentList = values?.documentList?.length > 0
        ?
        JSON.stringify(values?.documentList) : JSON.stringify([]);

    if (documentError) {
        return showToaster({ messageId: 'uploadDocument', toasterType: 'error' })
    } else {
        await dispatch(
            uploadDocument(documentList)
        )
    }

}

export default submit;